import { createContext, type PropsWithChildren, useMemo } from "react";

import { useNonNullableContext } from "app/common";

import type { CrmEnrichmentI18nKeys } from "../types/translations";
import type { CrmProvider } from "../types/types";
import createCrmEnrichmentI18nKeys from "../utils/translations";

type CrmEnrichmentContextValue = {
    readonly crmProvider: CrmProvider;
    readonly i18nKeys: CrmEnrichmentI18nKeys;
};

type CrmEnrichmentProviderProps = PropsWithChildren<{
    readonly crmProvider: CrmProvider;
}>;

const CrmEnrichmentContext = createContext<CrmEnrichmentContextValue | null>(null);

export const useCrmEnrichmentContext = (): CrmEnrichmentContextValue => useNonNullableContext(CrmEnrichmentContext);

export const CrmEnrichmentProvider = ({ children, crmProvider }: CrmEnrichmentProviderProps) => {
    const value = useMemo(
        () => ({
            crmProvider,
            i18nKeys: createCrmEnrichmentI18nKeys(crmProvider),
        }),
        [crmProvider],
    );

    return <CrmEnrichmentContext.Provider value={value}>{children}</CrmEnrichmentContext.Provider>;
};
